import { Button } from "antd";
import styled from "styled-components";

import { foundationColors } from "@/v1/themes/colors";

export const PageHeader = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: flex-start;
  margin-bottom: 24px;
`;

/* Matches the Command Hub: a link sitting on the heading baseline. */
export const LogsButton = styled(Button)`
  position: relative;
  bottom: 4px;
`;

export const Title = styled.h1`
  color: ${foundationColors["base-deep-purple"]};
  font-size: 24px;
  font-weight: 600;
  margin: 0;
`;

export const Description = styled.p`
  margin-bottom: 20px;
  max-width: 720px;
`;

export const Controls = styled.div`
  /* Labels sit above their select, so the buttons align on the control row. */
  align-items: flex-end;
  display: flex;
  gap: 8px;
`;

export const PeriodSelects = styled.div`
  display: flex;
  gap: 8px;
`;

export const HistorySection = styled.div`
  margin-top: 32px;
  max-width: 720px;
`;
